export default "__VITE_ASSET__DlNLcM$D__"